import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { OpeningHoursWrapper } from 'components/shared/OpeningHours/components/styles'
import { OpeningHoursDto } from 'store/api-slice/hooks'
import { FormattedMessage } from 'react-intl'

interface OpeningHoursDesktopProps {
    data: OpeningHoursDto[]
    hours: string[][]
}

const OpeningHoursDesktop = ({ data, hours }: OpeningHoursDesktopProps) =>
    hours.length && data ? (
        <Box gap={24} isFullWidth>
            <Text variant="heading5" color="grayscale_900">
                <FormattedMessage
                    id="upsells.wellness.modal_spa_opening_hours_heading"
                    defaultMessage="Godziny otwarcia"
                />
            </Text>
            <OpeningHoursWrapper
                columns={2}
                gap={40}
                pt={40}
                pl={40}
                pr={40}
                pb={40}
            >
                {data.map(({ rows, title }, columnIndex) =>
                    hours[columnIndex].length ? (
                        <Box
                            key={`${title}${columnIndex}`}
                            direction="column"
                            gap={12}
                            className="seasonBox"
                        >
                            <Text
                                variant="bodySmall"
                                color="grayscale_700"
                                key={title}
                            >
                                {title}
                            </Text>
                            <ul>
                                {rows?.map((row, rowIndex) => (
                                    <li key={row}>
                                        <Box
                                            direction="row"
                                            justify="space-between"
                                        >
                                            <Text
                                                variant="bodySmall"
                                                color="grayscale_900"
                                            >
                                                {row}
                                            </Text>
                                            <Text
                                                variant="bodySmall"
                                                color="wellness"
                                            >
                                                {hours[columnIndex][rowIndex]}
                                            </Text>
                                        </Box>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    ) : (
                        <></>
                    )
                )}
            </OpeningHoursWrapper>
        </Box>
    ) : (
        <></>
    )

export default OpeningHoursDesktop
